import { fileExtension, formatFileSize } from "@/utils/files";

export const ATTACHMENT_MAX_FILES = 10;
export const ATTACHMENT_MAX_FILE_BYTES = 25 * 1024 * 1024;

export const ATTACHMENT_ALLOWED_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "bmp",
  "heic",
  "mp4",
  "mov",
  "webm",
  "avi",
  "mkv",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "csv",
  "txt",
  "rtf",
  "odt",
  "ods",
  "odp",
  "zip",
  "rar",
  "7z",
];

export const ATTACHMENT_ACCEPT = ATTACHMENT_ALLOWED_EXTENSIONS.map((e) => `.${e}`).join(",");

export const ATTACHMENT_ERROR_TYPE =
  "File type not supported. Allowed: image, video, PDF, Office documents, text and archives.";
export const ATTACHMENT_ERROR_SIZE = `Each file must be ${formatFileSize(ATTACHMENT_MAX_FILE_BYTES)} or smaller.`;
export const ATTACHMENT_ERROR_COUNT = `You can attach up to ${ATTACHMENT_MAX_FILES} files per reply.`;
export const ATTACHMENT_ERROR_UPLOAD = "Upload failed. Please try again.";

export function isAllowedAttachment(filename: string): boolean {
  return ATTACHMENT_ALLOWED_EXTENSIONS.includes(fileExtension(filename));
}

export function acceptFiles(
  current: File[],
  incoming: File[],
  reservedSlots = 0,
): { files: File[]; error: string | null } {
  const accepted: File[] = [];
  let rejectedType = false;
  let rejectedSize = false;
  let rejectedCount = false;

  for (const file of incoming) {
    if (!isAllowedAttachment(file.name)) {
      rejectedType = true;
      continue;
    }
    if (file.size > ATTACHMENT_MAX_FILE_BYTES) {
      rejectedSize = true;
      continue;
    }
    if (reservedSlots + current.length + accepted.length >= ATTACHMENT_MAX_FILES) {
      rejectedCount = true;
      continue;
    }
    accepted.push(file);
  }

  const error = rejectedType
    ? ATTACHMENT_ERROR_TYPE
    : rejectedSize
      ? ATTACHMENT_ERROR_SIZE
      : rejectedCount
        ? ATTACHMENT_ERROR_COUNT
        : null;

  return { files: [...current, ...accepted], error };
}
